import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { BlockSectionLayoutProps } from '@ts-blocks/block-section-layout/interfaces'
import type { SectionTestProps } from '@ts-sections/section-test/interfaces'

interface SectionTestHookOptions {
  section: () => SectionTestProps
}

interface SectionTestHookReturn {
  refTitle: ComputedRef<string>
  refDescription: ComputedRef<string>
  refBackgroundColor: ComputedRef<NonNullable<BlockSectionLayoutProps['backgroundColor']>>
  refIsSingle: ComputedRef<boolean>
}

export const useSectionTest = ({ section }: SectionTestHookOptions): SectionTestHookReturn => {
  const refLayout = computed<BlockSectionLayoutProps | null>(() => section().layout ?? null)

  const refTitle = computed<string>(() => refLayout.value?.title ?? '')
  const refDescription = computed<string>(() => refLayout.value?.description ?? '')

  const refBackgroundColor = computed<NonNullable<BlockSectionLayoutProps['backgroundColor']>>(() => (
    refLayout.value?.backgroundColor ?? 'secondary'
  ))

  const refIsSingle = computed<boolean>(() => (section().tests?.length ?? 0) === 1)

  return {
    refTitle,
    refDescription,
    refBackgroundColor,
    refIsSingle,
  }
}
